// categories

export const getCategories = (state) =>
  Object.values(state?.categories?.byId ?? []).filter(
    (category) => category.productType === 'Food'
  )

export const getIsCategoriesLoading = (state) =>
  state?.categories?.isLoading ?? false

export const isLoadingCategories = (state) =>
  state?.categories?.isLoading ?? false
